import { action } from 'satcheljs/lib/legacy';
import { default as viewStateStore } from 'owa-mail-folder-store/lib/store/store';

export default action('showHideMoveFolderDialog')(function showHideMoveFolderDialog(
    shouldShowDialog: boolean
): void {
    viewStateStore.shouldShowMoveDialog = shouldShowDialog;
});
